module.exports = __webpack_public_path__ + "media/images/flags/1x1/plw-a3eefdc28fd0260f2d104163fed24eb4.svg";